/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createeventwithai3Inputs */

const en_createeventwithai3 = /** @type {(inputs: Createeventwithai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With AI`)
};

const de_createeventwithai3 = /** @type {(inputs: Createeventwithai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI`)
};

/**
* | output |
* | --- |
* | "With AI" |
*
* @param {Createeventwithai3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createeventwithai3 = /** @type {((inputs?: Createeventwithai3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createeventwithai3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createeventwithai3(inputs)
	return de_createeventwithai3(inputs)
});
export { createeventwithai3 as "createEventWithAi" }